export const ROUTER_PATH = {
	HOME: '/',
	BASE: '/views',
	CUSTOMER_SUPPORT: {
		EVENT: 'event',
		EVENT_DETAIL: 'event-detail',
		FAQ: 'faq',
		FAQ_DETAIL: 'faq-detail',
		NOTICE: 'notice',
		NOTICE_DETAIL: 'notice-detail'
	},
	INQUIRY: {
		PARTNERSHIP: 'partner-ship',
		SERVICE: 'service'
	},
	FUNCTION: {
		ROOT: 'function',
		MAIN: 'main',
		CONVENIENCE: 'convenience'
	},
	CONSULTING: 'consulting',
	MAIN: 'main',
	INTRO: 'intro',
	WHY: 'why',
	PRICE: 'price',
	PROMOTION: 'promotion',
	POLICY: {
		TERMS: 'terms',
		TERMS2: 'terms_2',
		TERMS_240214: 'terms_240214',
		PRIVACY: 'privacy',
		PRIVACY_240214: 'privacy_240214',
		PRIVACY_EMAIL: 'email'
	}
};

export const ROUTER_TITLES = {
	HOME: '홈',
	CUSTOMER_SUPPORT: {
		ROOT: '고객지원',
		EVENT: '이벤트',
		FAQ: '자주 묻는 질문',
		NOTICE: '공지 사항'
	},
	INQUIRY: {
		ROOT: '서비스 문의',
		PARTNERSHIP: '제휴 문의',
		SERVICE: '서비스 문의'
	},
	FUNCTION: {
		ROOT: '주요 기능',
		MAIN: '주요 기능',
		CONVENIENCE: '편의 기능'
	},
	MAIN: 'STELLA',
	INTRO: '서비스 소개',
	PRICE: '가격정책',
	CONSULTING: '전문가 문의',
	PROMOTION: '성장 UP 프로모션',
	POLICY: {
		TERMS: '이용약관',
		PRIVACY: '개인정보 처리방침',
		PRIVACY_EMAIL: '이메일 무단수집거부'
	}
};

export const TOS_GRP_ID = {
	PRIVACY: {
		PRIVACY: 'TGP0000008',
		PRIVACY_EMAIL: 'TGP0000008'
	},
	TERMS: {
		TERMS: 'TGP0000008',
		TERMS_HOME: 'TGP0000008'
	}
};

export const NAV_PATH = {
	HOME: `${ROUTER_PATH.HOME}`,
	CUSTOMER_SUPPORT: {
		ROOT: `${ROUTER_PATH.BASE}/${ROUTER_PATH.CUSTOMER_SUPPORT.EVENT}`,
		EVENT: `${ROUTER_PATH.BASE}/${ROUTER_PATH.CUSTOMER_SUPPORT.EVENT}`,
		EVENT_DETAIL: `${ROUTER_PATH.BASE}/${ROUTER_PATH.CUSTOMER_SUPPORT.EVENT_DETAIL}`,
		FAQ: `${ROUTER_PATH.BASE}/${ROUTER_PATH.CUSTOMER_SUPPORT.FAQ}`,
		FAQ_DETAIL: `${ROUTER_PATH.BASE}/${ROUTER_PATH.CUSTOMER_SUPPORT.FAQ_DETAIL}`,
		NOTICE: `${ROUTER_PATH.BASE}/${ROUTER_PATH.CUSTOMER_SUPPORT.NOTICE}`,
		NOTICE_DETAIL: `${ROUTER_PATH.BASE}/${ROUTER_PATH.CUSTOMER_SUPPORT.NOTICE_DETAIL}`
	},
	INQUIRY: {
		ROOT: `${ROUTER_PATH.BASE}/${ROUTER_PATH.INQUIRY.SERVICE}`,
		PARTNERSHIP: `${ROUTER_PATH.BASE}/${ROUTER_PATH.INQUIRY.PARTNERSHIP}`,
		SERVICE: `${ROUTER_PATH.BASE}/${ROUTER_PATH.INQUIRY.SERVICE}`
	},
	FUNCTION: {
		ROOT: `${ROUTER_PATH.BASE}/${ROUTER_PATH.FUNCTION.MAIN}`,
		MAIN: `${ROUTER_PATH.BASE}/${ROUTER_PATH.FUNCTION.MAIN}`,
		CONVENIENCE: `${ROUTER_PATH.BASE}/${ROUTER_PATH.FUNCTION.CONVENIENCE}`
	},
	MAIN: `${ROUTER_PATH.BASE}/${ROUTER_PATH.MAIN}`,
	INTRO: `${ROUTER_PATH.BASE}/${ROUTER_PATH.INTRO}`,
	WHY: `${ROUTER_PATH.BASE}/${ROUTER_PATH.WHY}`,
	PRICE: `${ROUTER_PATH.BASE}/${ROUTER_PATH.PRICE}`,
	CONSULTING: `${ROUTER_PATH.BASE}/${ROUTER_PATH.CONSULTING}`,
	BLOG: `https://blog.stella-erp.co.kr`,
	PROMOTION: `${ROUTER_PATH.BASE}/${ROUTER_PATH.PROMOTION}`,
	POLICY: {
		TERMS: `${ROUTER_PATH.BASE}/${ROUTER_PATH.POLICY.TERMS}`,
		TERMS2: `${ROUTER_PATH.BASE}/${ROUTER_PATH.POLICY.TERMS2}`,
		TERMS_240214: `${ROUTER_PATH.BASE}/${ROUTER_PATH.POLICY.TERMS_240214}`,
		PRIVACY: `${ROUTER_PATH.BASE}/${ROUTER_PATH.POLICY.PRIVACY}`,
		PRIVACY_240214: `${ROUTER_PATH.BASE}/${ROUTER_PATH.POLICY.PRIVACY_240214}`,
		PRIVACY_EMAIL: `${ROUTER_PATH.BASE}/${ROUTER_PATH.POLICY.PRIVACY_EMAIL}`
	}
};
